import Vue from 'vue'
import Router from 'vue-router'
import navLayout from '@/components/layout/navLayout.vue'

Vue.use(Router)
let router = new Router({
  mode: 'hash',
  // base: '/website/',
  routes: [
    {
      path: '/',
      component: navLayout,
      redirect: '/home',
      children: [
        {
          path: '/home',
          component: resolve => require(['@/views/index/index.vue'], resolve),
          meta: {
            title: "首页"
          },
        },
      ]
    },
    {
      path: '/home/expertRecruit',
      // component: expertRecruitContainer,
        component: resolve => require(['@/components/home/expertRecruit'],resolve),
      meta:{
        title:"专家招募"
      },
    },
    {
      path: '/home/appointConsultation',
      name: 'appointConsultation',
      // component: appointConsultationContainer
      component: resolve => require(['@/components/common/appointConsultation'],resolve),
      meta:{
        title:"详细了解"
      },
    },
    {
      path: '/solution',
      component: navLayout,
      redirect: 'intelligentManufacturing',
      children: [
        {
          path: 'talentDevelopment',
          component: resolve => require(['@/views/solution/talentDevelopment.vue'], resolve),
          meta: {
            title: "解决方案-组织与人才发展"
          },
        },
        {
          path: 'planning',
          component: resolve => require(['@/views/solution/planning.vue'], resolve),
          meta: {
            title: "解决方案-企业核心能力咨询规划"
          },
        },
      ]
    },
    {
      path: '/product',
      component: navLayout,
      redirect: 'cloud',
      children: [
        {
          path: 'cloud',
          component: resolve => require(['@/views/product/cloud.vue'], resolve),
          meta: {
            title: "产品-产业云图"
          },
        },
        {
          path: 'talents',
          component: resolve => require(['@/views/product/talents.vue'], resolve),
          meta: {
            title: "产品-组织人才与发展"
          },
        },
        {
          path: 'consultation',
          component: resolve => require(['@/views/product/consultation.vue'], resolve),
          meta: {
            title: "产品-企业核心能力评估诊断"
          },
        },
        {
          path: 'digitalHuman',
          component: resolve => require(['@/views/product/digitalHuman.vue'], resolve),
          meta: {
            title: "产品-岗位数字人"
          },
        },
      ]
    },
    {
      path: '/intelligent',
      component: navLayout,
      redirect: '/intelligent/index',
      children: [
        {
          path: 'index',
          component: resolve => require(['@/views/intelligent/index.vue'], resolve),
          meta: {
            title: "智能制造"
          },
        },
        {
          path: 'solution',
          component: resolve => require(['@/views/intelligent/solution.vue'], resolve),
          meta: {
            title: "解决方案"
          },
        },
      ]
    },
    {
      path: '/case',
      component: navLayout,
      redirect: '/case/list',
      children: [
        {
          path: 'list',
          component: resolve => require(['@/views/case/list.vue'], resolve),
          meta: {
            title: "客户案例"
          },
        },
        {
          path: 'details',
          component: resolve => require(['@/views/case/details.vue'], resolve),
          meta: {
            title: "客户案例"
          },
        },
      ]
    },
    {
      path: '/news',
      component: navLayout,
      redirect: '/news/list',
      children: [
        {
          path: 'list',
          component: resolve => require(['@/views/news/list.vue'], resolve),
          meta: {
            title: "新闻动态"
          },
        },
        {
          path: 'details',
          component: resolve => require(['@/views/news/details.vue'], resolve),
          meta: {
            title: "新闻动态"
          },
        },
      ]
    },
    {
      path: '/platform',
      component: navLayout,
      redirect: '/platform/index',
      children: [
        {
          path: 'index',
          component: resolve => require(['@/views/service/index.vue'], resolve),
          meta: {
            title: "平台服务"
          },
        }
      ]
    },
    {
      path: '/about',
      component: navLayout,
      redirect: '/about/index',
      children: [
        {
          path: 'index',
          component: resolve => require(['@/views/about/index.vue'], resolve),
          meta: {
            title: "关于我们"
          },
        }
      ]
    },
  ]
})
router.beforeEach((to, from, next) => {
  if (to.meta.title) {//如果设置标题，拦截后设置标题
    document.title = to.meta.title
  }
  next();
})
// 路由跳转回到顶部
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
})
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js